import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
import {RiListCheck3} from "react-icons/ri";
import Select from "react-select";
import "react-multi-date-picker/styles/layouts/mobile.css"
import {CgPlayListCheck} from "react-icons/cg";

function Agents() {

    const [isLoaded, setIsLoaded] = React.useState(false);

    const [pagesCount, setPagesCount] = React.useState( []);
    const [page, setPage] = React.useState( 1);
    const [total, setTotal] = React.useState( 0);
    const [search, setSearch] = React.useState( '');
    const [agents, setAgents] = React.useState( null);
    const [selectOptions, setSelectOptions] = React.useState( null);
    const [selectedOptions, setSelectedOptions] = React.useState( null);



    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        let params = {
            count: 200,
            page: 1,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            processFor: 'CRM',
        }
        API.getVendors(params)
            .then((response) => {

                const vendors = response.data;
                let options = [];
                for (let data in vendors) {

                    options.push({
                        value: vendors[data].id,
                        label: vendors[data].title + " - " + vendors[data].city,
                    })
                }
                setSelectOptions(options)


            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }, []);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        let params = {
            count: 30,
            page: page,
            list: 1,
            vendor_id: selectedOptions,
            orderBy: 'created_at',
            orderType: 'desc',
            processFor: 'CRM',
            search
        }

        API.getAgents(params)
            .then((response) => {
                setIsLoaded(true)
                // console.log(response.data[0].data)
                setAgents(response.data)
                setTotal(response.meta.total)
                setPagesCount( Array.from({length: response.meta.last_page}, (_, index) => index + 1))
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }, [selectedOptions, page,search]);



    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header/>
            <Navbar page="agents"/>

            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <RiListCheck3 className='ms-2' />
گزارش عاملین فروش
                    </h1>
                    {/*   <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item">Pages</li>
                            <li className="breadcrumb-item active">Blank</li>
                        </ol>
                    </nav>*/}
                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body pt-4 table-responsive">
                                    <div className="row filter-box mb-5 pb-2 rounded text-small-2">

                                        <div className="col-md-3  mt-3">
                                            <Select
                                                options={selectOptions}
                                                placeholder="فیلتر بر اساس نماینده"
                                                value={selectedOptions}

                                                isSearchable={true}
                                                onChange={

                                                    (event) => {
                                                        setSelectedOptions(event)
                                                        setPage(1)
                                                    }
                                                }
                                            />
                                        </div>
                                        <div className="form-floating col-md-4 mt-2">
                                            <input type="text"
                                                   className="form-control px-5 "
                                                   id="document_title" name="document_title"
                                                   placeholder="    جستجو (نام و موبایل) "
                                                   value={search}
                                                   onChange={
                                                       (val) => {
                                                           setSearch(val.target.value)
                                                       }
                                                   }/>
                                            <label htmlFor="document_title" className="super-small">
                                                جستجو (نام و موبایل)
                                                </label>
                                        </div>


                                    </div>

                                    <div className="row mb-3 pb-2 border-bottom ">
                                        <div
                                            className="col-6 text-end fw-bold text-small-2 pe-3 text-primary opacity-75">
                                            <CgPlayListCheck className='ms-2 text-big-4'/>
                                            تعداد کل عاملین:
                                            &nbsp;
                                            {total}
                                        </div>
                                        <div className="col-6 text-start text-small-3">
                                            صفحه:
                                            <select className='bg-secondary-subtle border-0 px-2 mx-2'
                                                    value={page}
                                                    onChange={(val) => {
                                                        setPage(val.target.value)
                                                    }}
                                            >

                                                {
                                                    pagesCount.map(pc => {
                                                        return (
                                                            <option value={pc} key={pc}>{pc}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <table className="table table-striped ">
                                        <thead>
                                        <tr className='text-small-2 text-muted'>
                                            <th scope="col" className='bg-success-subtle rounded-end-3'>#</th>
                                            <th scope="col" className='bg-success-subtle'>نام و نام خانوادگی</th>
                                            <th scope="col" className='bg-success-subtle'>شماره تماس</th>
                                            <th scope="col" className='bg-success-subtle'>نام نماینده</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            agents?.map((agent ,index) => {
                                                return (
                                                    <tr key={agent.id}
                                                        role='button'
                                                    >
                                                        <th scope="row">
                                                            {(index + 1) + ((page-1) * 30)}
                                                        </th>
                                                        <td>
                                                            {agent.name}
                                                            &nbsp;
                                                            {agent.surname}
                                                        </td>
                                                        <td>
                                                            {agent.username}
                                                        </td>
                                                        <td>
                                                            {agent.vendor}
                                                        </td>

                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>


                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default Agents;